import axios from "axios";

export default {
  state: {
    appezzamenti: [],
    posizioni: {},      // Map<id_appezzamento → Array<PosizioneSerraAppezzamento>>
    blocchi: {},        // Map<id_appezzamento → Array<BloccoAppezzamento>>
    layout_mappa: {},   // Map<`${id_stagione}_${id_appezzamento}` → LayoutStagione>
  },
  getters: {
    getAppezzamenti(state) {
      return state.appezzamenti;
    },
    getPosizioniAppezzamento(state) {
      return (id_appezzamento) => state.posizioni[id_appezzamento] || [];
    },
    getBlocchiAppezzamento(state) {
      return (id_appezzamento) => state.blocchi[id_appezzamento] || [];
    },
    getLayoutMappa(state) {
      return (id_stagione, id_appezzamento) =>
        state.layout_mappa[`${id_stagione}_${id_appezzamento}`] || null;
    },
  },
  mutations: {
    setAppezzamenti(state, list) {
      state.appezzamenti = list;
    },
    addAppezzamento(state, app) {
      state.appezzamenti.push(app);
    },
    updateAppezzamento(state, app) {
      state.appezzamenti = state.appezzamenti.map((a) => (a.id === app.id ? app : a));
    },
    removeAppezzamento(state, id) {
      state.appezzamenti = state.appezzamenti.filter((a) => a.id !== id);
    },
    setPosizioniAppezzamento(state, { id_appezzamento, posizioni }) {
      state.posizioni = { ...state.posizioni, [id_appezzamento]: posizioni };
    },
    addPosizioneAppezzamento(state, pos) {
      const lista = state.posizioni[pos.id_appezzamento] || [];
      state.posizioni = {
        ...state.posizioni,
        [pos.id_appezzamento]: [...lista, pos],
      };
    },
    updatePosizioneAppezzamento(state, pos) {
      const lista = state.posizioni[pos.id_appezzamento] || [];
      state.posizioni = {
        ...state.posizioni,
        [pos.id_appezzamento]: lista.map((p) => (p.id === pos.id ? pos : p)),
      };
    },
    removePosizioneAppezzamento(state, { id, id_appezzamento }) {
      const lista = state.posizioni[id_appezzamento] || [];
      state.posizioni = {
        ...state.posizioni,
        [id_appezzamento]: lista.filter((p) => p.id !== id),
      };
    },
    setBlocchiAppezzamento(state, { id_appezzamento, blocchi }) {
      state.blocchi = { ...state.blocchi, [id_appezzamento]: blocchi };
    },
    addBloccoAppezzamento(state, blocco) {
      const lista = state.blocchi[blocco.id_appezzamento] || [];
      state.blocchi = { ...state.blocchi, [blocco.id_appezzamento]: [...lista, blocco] };
    },
    updateBloccoAppezzamento(state, blocco) {
      const lista = state.blocchi[blocco.id_appezzamento] || [];
      state.blocchi = {
        ...state.blocchi,
        [blocco.id_appezzamento]: lista.map((b) => (b.id === blocco.id ? blocco : b)),
      };
    },
    removeBloccoAppezzamento(state, { id, id_appezzamento }) {
      const lista = state.blocchi[id_appezzamento] || [];
      state.blocchi = { ...state.blocchi, [id_appezzamento]: lista.filter((b) => b.id !== id) };
    },
    setLayoutMappa(state, { id_stagione, id_appezzamento, layout }) {
      const key = `${id_stagione}_${id_appezzamento}`;
      state.layout_mappa = { ...state.layout_mappa, [key]: layout };
    },
  },
  actions: {
    fetchAppezzamenti({ commit }) {
      const url = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti";
      const auth = this.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .get(url, { auth })
          .then((response) => {
            commit("setAppezzamenti", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            console.error("Errore nel recupero degli appezzamenti:", error);
            reject(error);
          })
      );
    },
    saveAppezzamento(context, payload) {
      const url = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti";
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .post(url, payload, { auth })
          .then((response) => {
            context.commit("addAppezzamento", response.data);
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    updateAppezzamento(context, { id, payload }) {
      const url = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/" + id;
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .put(url, payload, { auth })
          .then((response) => {
            context.commit("updateAppezzamento", response.data);
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    deleteAppezzamento(context, id) {
      const url = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/" + id;
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .delete(url, { auth })
          .then((response) => {
            context.commit("removeAppezzamento", id);
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    fetchPosizioniAppezzamento(context, id_appezzamento) {
      if (context.state.posizioni[id_appezzamento]) {
        return Promise.resolve(context.state.posizioni[id_appezzamento]);
      }
      const url =
        process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/" + id_appezzamento + "/posizioni";
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .get(url, { auth })
          .then((response) => {
            context.commit("setPosizioniAppezzamento", {
              id_appezzamento,
              posizioni: response.data,
            });
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    savePosizioneAppezzamento(context, { id_appezzamento, payload }) {
      const url =
        process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/" + id_appezzamento + "/posizioni";
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .post(url, payload, { auth })
          .then((response) => {
            context.commit("addPosizioneAppezzamento", response.data);
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    updatePosizioneAppezzamento(context, { id_posizione, payload }) {
      // Commit ottimistico: aggiorna subito lo store senza aspettare il backend.
      // Necessario perché il backend potrebbe non restituire ancora tutti i campi
      // (es. rotazione) nella risposta, causando regressioni nello stato locale.
      for (const [id_app, lista] of Object.entries(context.state.posizioni)) {
        const current = lista.find((p) => String(p.id) === String(id_posizione));
        if (current) {
          context.commit("updatePosizioneAppezzamento", {
            ...current,
            ...payload,
            id_appezzamento: id_app,
          });
          break;
        }
      }

      const url =
        process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/posizioni/" + id_posizione;
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .put(url, payload, { auth })
          .then((response) => {
            // Aggiorna di nuovo con i dati definitivi del backend (se disponibili)
            if (response.data && response.data.id_appezzamento) {
              context.commit("updatePosizioneAppezzamento", response.data);
            }
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    deletePosizioneAppezzamento(context, { id_posizione, id_appezzamento }) {
      const url =
        process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/posizioni/" + id_posizione;
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .delete(url, { auth })
          .then((response) => {
            context.commit("removePosizioneAppezzamento", {
              id: id_posizione,
              id_appezzamento,
            });
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },

    /* ---- Blocchi appezzamento ---- */
    fetchBlocchiAppezzamento(context, id_appezzamento) {
      if (context.state.blocchi[id_appezzamento]) {
        return Promise.resolve(context.state.blocchi[id_appezzamento]);
      }
      const url  = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/" + id_appezzamento + "/blocchi";
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .get(url, { auth })
          .then((response) => {
            context.commit("setBlocchiAppezzamento", { id_appezzamento, blocchi: response.data });
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    saveBloccoAppezzamento(context, { id_appezzamento, payload }) {
      const url  = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/" + id_appezzamento + "/blocchi";
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .post(url, payload, { auth })
          .then((response) => {
            context.commit("addBloccoAppezzamento", response.data);
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    updateBloccoAppezzamento(context, { id_blocco, payload }) {
      // Commit ottimistico
      for (const [id_app, lista] of Object.entries(context.state.blocchi)) {
        const current = lista.find((b) => String(b.id) === String(id_blocco));
        if (current) {
          context.commit("updateBloccoAppezzamento", { ...current, ...payload, id_appezzamento: id_app });
          break;
        }
      }
      const url  = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/blocchi/" + id_blocco;
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .put(url, payload, { auth })
          .then((response) => {
            if (response.data && response.data.id_appezzamento) {
              context.commit("updateBloccoAppezzamento", response.data);
            }
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
    fetchLayoutMappa(context, { id_stagione, id_appezzamento }) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/stagione/${id_stagione}/mappa/${id_appezzamento}`;
      return axios.get(url, { auth: context.getters.get_credential }).then((response) => {
        context.commit('setLayoutMappa', { id_stagione, id_appezzamento, layout: response.data });
        return response.data;
      });
    },
    eliminaLayout(context, { id_layout, id_stagione, id_appezzamento }) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/layout-stagione/${id_layout}`;
      return axios.delete(url, { auth: context.getters.get_credential }).then(() => {
        return context.dispatch('fetchLayoutMappa', { id_stagione, id_appezzamento });
      });
    },
    forkLayout(context, { id_stagione, id_appezzamento }) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/stagione/${id_stagione}/mappa/${id_appezzamento}/fork`;
      return axios.post(url, {}, { auth: context.getters.get_credential }).then((r) => {
        context.commit('setLayoutMappa', { id_stagione, id_appezzamento, layout: r.data });
        return r.data;
      });
    },
    // ATTENZIONE — non più raggiungibile dalla UI (Fase 0 separazione live/fork).
    // Nonostante il nome, il primo POST crea una Serra LIVE permanente: la serra
    // comparirebbe nella mappa aziendale e in tutti gli altri fork stagionali.
    // Richiede un endpoint backend dedicato (serra esistente solo nel LayoutMappa)
    // prima di poter essere riabilitata.
    saveSerraInFork(context, { id_layout, id_stagione, id_appezzamento, payload }) {
      const auth = context.getters.get_credential;
      const { nome, tipo, posizione, larghezza, lunghezza } = payload;
      return axios
        .post(`${process.env.VUE_APP_API_ROOT}/admin/serre`, { nome, tipo, posizione, larghezza, lunghezza }, { auth })
        .then((r) => {
          const serra = r.data;
          context.commit('addSerra', serra);
          return axios
            .post(
              `${process.env.VUE_APP_API_ROOT}/admin/layout-stagione/${id_layout}/serre`,
              { id_serra: serra.id, x: payload.x ?? 0, y: payload.y ?? 0 },
              { auth }
            )
            .then((r2) => {
              context.commit('setLayoutMappa', { id_stagione, id_appezzamento, layout: r2.data });
              return serra;
            });
        });
    },
    addSerraFork(context, { id_layout, id_stagione, id_appezzamento, payload }) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/layout-stagione/${id_layout}/serre`;
      return axios.post(url, payload, { auth: context.getters.get_credential }).then((r) => {
        context.commit('setLayoutMappa', { id_stagione, id_appezzamento, layout: r.data });
        return r.data;
      });
    },
    updateSerraFork(context, { id_layout, id_pos, id_stagione, id_appezzamento, payload }) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/layout-stagione/${id_layout}/serre/${id_pos}`;
      return axios.put(url, payload, { auth: context.getters.get_credential }).then((r) => {
        context.commit('setLayoutMappa', { id_stagione, id_appezzamento, layout: r.data });
        return r.data;
      });
    },
    removeSerraFork(context, { id_layout, id_pos, id_stagione, id_appezzamento }) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/layout-stagione/${id_layout}/serre/${id_pos}`;
      return axios.delete(url, { auth: context.getters.get_credential }).then((r) => {
        context.commit('setLayoutMappa', { id_stagione, id_appezzamento, layout: r.data });
        return r.data;
      });
    },
    deleteBloccoAppezzamento(context, { id_blocco, id_appezzamento }) {
      const url  = process.env.VUE_APP_API_ROOT + "/admin/appezzamenti/blocchi/" + id_blocco;
      const auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .delete(url, { auth })
          .then((response) => {
            context.commit("removeBloccoAppezzamento", { id: id_blocco, id_appezzamento });
            resolve(response.data);
          })
          .catch((error) => reject(error))
      );
    },
  },
};
